import { atMapsToGeojson } from '@alltrails/maps/utils/legacyGeoJSONConversions';
import { loadVerifiedRoute } from 'utils/requests/at_map_requests';

export default async function fetchAndDecodeCoordinates(trailId: number) {
  if (!trailId) {
    return null;
  }
  try {
    const map = await loadVerifiedRoute(trailId);
    return map ? atMapsToGeojson([map]) : null;
  } catch (e) {
    console.log('getGeojsonAndBounds error= ', e);
    return null;
  }
}
